module.exports = __webpack_public_path__ + "img/car_00018.fbe24d52.jpg";